import { getCustomerDefaults } from '../../../services/requests/orders/orders-requests';

// Legacy `SetCustomerInfo()` — copy the selected customer's default field values
// onto the order (address block, PO number, recommended shipping location,
// default delivery type, notes, and the Dewar context labels). Only values the
// backend returns non-null are applied. Shared by the Order Info customer
// pickers and the create-page customer dropdown.
export const applyCustomerDefaultsFor = async (orderTypeId: number, customerId: any, setValue: any) => {
  if (customerId == null || customerId === '') return;

  const d = await getCustomerDefaults(orderTypeId, customerId);
  if (!d) return;

  const set = (name: string, val: any) => {
    if (val !== null && val !== undefined) setValue(name, val);
  };
  set('address1', d.address1);
  set('address2', d.address2);
  set('city', d.city);
  set('state', d.state);
  set('zip', d.zip);
  set('country', d.country);
  set('ponumber', d.ponumber);
  if (d.shippingLocationId) setValue('shippingLocationId', d.shippingLocationId);
  if (d.deliveryTypeId) setValue('deliveryTypeId', d.deliveryTypeId);
  set('deliveryInstructions', d.deliveryInstructions);
  set('otherNotes', d.otherNotes);
  set('logisticsComments', d.logisticsComments);
  // Contact details (legacy SetContactNameInfo + SetContactDetails). These are
  // always applied (blank clears) so switching customers refreshes the contact.
  setValue('orderedBy', d.orderedBy ?? '');
  setValue('orderedByPhone', d.orderedByPhone ?? '');
  setValue('orderedByEmail', d.orderedByEmail ?? '');
  setValue('orderedByFax', d.orderedByFax ?? '');
  // Dewar-only read-only context labels.
  set('dewarParentAccount', d.dewarParentAccount);
  set('dewarAccountType', d.dewarAccountType);
  set('dewarPoInfo', d.dewarPoInfo);
  set('dewarBillingStatus', d.dewarBillingStatus);
  set('dewarCreditManager', d.dewarCreditManager);
  set('dewarTerms', d.dewarTerms);
  set('dewarCbtNotes', d.dewarCbtNotes);
};
